import { Navigate, useLocation } from 'react-router-dom'
import { useUserAuthStore } from '../../store/userAuthStore'

interface UserProtectedRouteProps {
  children: React.ReactNode
  requirePin?: boolean
}

export function UserProtectedRoute({ children, requirePin = true }: UserProtectedRouteProps) {
  const location = useLocation()
  const { isAuthenticated, isHydrated, isPinVerified } = useUserAuthStore()

  if (!isHydrated) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900" />
          <p className="mt-2 text-sm text-gray-600">Loading...</p>
        </div>
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login?mode=user" replace />
  }

  if (requirePin && !isPinVerified) {
    return <Navigate to="/user/pin" replace />
  }

  if (!requirePin && isPinVerified && location.pathname !== '/user') {
    return <Navigate to="/user" replace />
  }

  return <>{children}</>
}
